import { Icon12, Icon16, Icon18, Icon7, IconOk } from '@/shared/ui/Icons'

const getPcLevelIcon = (pcAge: number) => {
    const pcLevel = pcAge

    if (pcLevel) {
        if (pcLevel > 3 && pcLevel <= 7) return <Icon7 />
        else if (pcLevel > 7 && pcLevel <= 12) return <Icon12 />
        else if (pcLevel > 12 && pcLevel <= 16) return <Icon16 />
        else if (pcLevel > 16) return <Icon18 />
    }
    return <IconOk />
}
export { getPcLevelIcon }
